<template>
    <div class="account-settings">
      <div class="mt-5 pt-4">
         <nav class="mb-5"
            style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='white'/%3E%3C/svg%3E&#34;);"
            aria-label="breadcrumb">
            <ol class="breadcrumb">
               <li class="breadcrumb-item" style="color:#435666;" aria-current="page">
                  <span class="custom-span-lg"> Extension Configuration
                     <i class="fa-solid fa-arrow-right">
                     </i>
                  </span>
                  <span class="custom-span-no-weight"> &nbsp;Account Settings</span>
               </li>
            </ol>
         </nav>
      </div>
 
       <div>
          <AccountSettings/>
       </div>
       
 
    </div>
 </template>
 
 <script>
 import AccountSettings from '@/components/ExtensionConfiguration/AccountSettings/AccountSettings.vue';
 
 export default {
 
     components: {
        AccountSettings,
     },
 
 }
 </script>


<style>
.custom-span-lg {
   font-size: 24px;
   line-height: 24px;
   font-weight: bold;
}

.custom-span-no-weight {
   font-size: 24px;
   line-height: 24px;
   font-weight: 250;
}

</style>